export const AppSecretType = {
	webhook_signing: "webhook_signing",
};
